package com.evoapps.evoshift

import com.evoapps.evoshift.domain.provider.SignupSource

/**
 * SH-240: the campaign labels of the address the web app was opened with (`/web?utm_source=…`,
 * passed on by the product site's site-source.js, or an e-mailed `/join?code=…&utm_source=mail`
 * link). Read once at start (main.kt), before the app changes the address, and kept in memory only:
 * nothing is stored in the browser. Sent with a sign-up in this visit (AuthRepositoryImpl).
 */
object WebSignupSource {
    var captured: SignupSource? = null
        private set

    fun capture(search: String?) {
        captured = SignupSource.fromQuery(search)
    }
}
